<template>
  <label title="Download [Printer Counters] installer latest version" action="#" method="get" class="sidebar-form largeDownlaodBtn" @click="downloadClick()">
    <div class="input-group btnUpload" style="padding: 5px 10px; font-size: 20px; margin: 5px auto;">
      <img style="width: 22px;" :src="img" alt="">
      <span class="btnUpload" style="padding-left: 10px;">{{title}}</span>
    </div>
    <div style="width: 180px; text-align: center; color: #000; font-weight: normal; font-size: 14px; margin: 5px auto;">
      {{info}}
    </div>
    <div class="input-group btnUpload" style="padding: 5px 10px; margin: 0 auto;">
      <i :class="['btnUpload', icon]"></i>
      <span class="btnUpload" style="padding-left: 10px;">{{btnText}}</span>
    </div>
  </label>
</template>
<script>
  export default {
    name: 'downBtn',
    props: ['title', 'info', 'img', 'icon', 'btnText'],
    data () {
      return {
      }
    },
    computed: {
    },
    created () {
    },
    methods: {
      downloadClick () {
        this.$emit('click')
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// downloadBtn.vue?23cbbf6e